/* MUVA — add-to-cart for the cart upsell cards (snippets/cart-upsell.liquid). */
(function () {
  if (window.__muvaCartUpsell) return;
  window.__muvaCartUpsell = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-upsell-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    const wrapper = button.closest('.cart-upsell');
    const error = wrapper && wrapper.querySelector('[data-cart-upsell-error]');
    if (error) error.textContent = '';
    button.disabled = true;

    const drawer = document.querySelector('cart-drawer');
    const inDrawer = !!(drawer && drawer.contains(button));
    const item = { id: Number(button.dataset.variantId), quantity: 1 };
    if (button.dataset.preorder) item.properties = { 'Pre-order': 'Ships in 10–15 business days' };
    const body = { items: [item] };
    if (inDrawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id).filter(Boolean);
      body.sections_url = window.location.pathname;
    }

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const res = await fetch(root.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const state = await res.json();
      if (!res.ok) throw new Error(state.description || state.message || 'Could not add this to your cart.');

      if (inDrawer && state.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(state);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
        }
      } else {
        window.location.reload();
      }
    } catch (e) {
      if (error) error.textContent = e.message;
      button.disabled = false;
    }
  });
})();
